import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import TextLink from "Shared/components/text-link";
import { useGlobalNotificationBanner } from "Shared/util/custom-hooks";

export const getBannerId = (bankName: string) =>
    `PayoutInformation::ConsentExpired::${bankName}`;

export const useAddConsentExpiredBanners = () => {
    const { push } = useHistory();
    const { addGlobalNotificationBanner, NotificationBannerType } =
        useGlobalNotificationBanner();

    return useCallback(
        (bankNames: string[]): string[] => {
            const navigateToPage = () =>
                push("/company-settings/payout-information");

            return (bankNames || []).map((bankName) => {
                const bannerId = getBannerId(bankName);

                addGlobalNotificationBanner(
                    (tnb) => (
                        <>
                            {tnb.format(
                                tnb.globalPayoutInformationBanner
                                    .consentExpiredMessage,
                                { bankName },
                            )}{" "}
                            <TextLink
                                link={navigateToPage}
                                text={
                                    tnb.globalPayoutInformationBanner
                                        .renewConsent
                                }
                            />
                        </>
                    ),
                    NotificationBannerType.Error,
                    false,
                    bannerId,
                );

                return bannerId;
            });
        },
        [addGlobalNotificationBanner, push],
    );
};
